import axios from 'axios';

const api = axios.create({
  baseURL: process.env.REACT_APP_API_BASE_URL || 'https://crosslisting-backend-aacranbzdyd3ffbd.centralindia-01.azurewebsites.net',
});

// Attach JWT token from localStorage to every request
// Note: We use localStorage as fallback since React context can't be accessed in interceptors
api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('token');
    if (token) {
      config.headers['Authorization'] = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

// Handle 401 errors globally
api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      // Token expired or invalid - clear auth and redirect
      localStorage.removeItem('token');
      localStorage.removeItem('user');
      localStorage.removeItem('company_id');
      window.location.href = '/login';
    }
    return Promise.reject(error);
  }
);

export default api;
